module.exports = __webpack_public_path__ + "static/media/pokemon_found.7b33a521.svg";